import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { NEWEB_FRONTEND_TO_BACKEND } from '@dragonfruit/constants/paymentTypes';

import { resetCheckoutNewebState } from '@dragonfruit/redux/purchase/checkoutNeweb';

class NewebCheckout extends Component {
  static propTypes = {
    newebType: string.isRequired,
    resetCheckoutNewebState: func.isRequired,
    selectedPayment: object.isRequired,
    selectedPlan: object.isRequired,
    setReadyToSubmit: func.isRequired,
    t: func.isRequired,
    triggerSubmit: bool.isRequired,
    onPaymentSubmit: func.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { triggerSubmit, setReadyToSubmit, newebType } = this.props;

    if (prevProps.triggerSubmit !== triggerSubmit && triggerSubmit) {
      this.onNewebSubmit();
      setReadyToSubmit(false);
    }

    if (prevProps.newebType !== newebType) {
      const { resetCheckoutNewebState } = this.props;
      resetCheckoutNewebState();
    }
  }

  onNewebSubmit = () => {
    const {
      selectedPlan: {
        id: planId,
        name,
        currency,
        planType,
        sellingTypes,
        questionQuota,
      },
      selectedPayment: { price, sku, id: paymentMethodId },
      newebType,
      onPaymentSubmit,
    } = this.props;
    onPaymentSubmit({
      paymentMethodId,
      paymentType: NEWEB_FRONTEND_TO_BACKEND[newebType],
      gtmData: {
        // The data below comes from selectedPlan object.
        planId,
        name,
        planType,
        sellingTypes,
        questionQuota,
        currency,
        // The data below comes from paymentMethod object in the plan.
        price,
        sku,
      },
    });
  };
  render() {
    // The payment method Neweb doesn't need a layout.
    return <div />;
  }
}

export default translate('purchase')(
  connect(null, {
    resetCheckoutNewebState,
  })(NewebCheckout)
);



// WEBPACK FOOTER //
// ./app/components/PaymentHandler/NewebCheckout/NewebCheckout.jsx